import { forwardRef, memo } from 'react'
import classNames from 'classnames'
import uniqid from 'uniqid'
import { Typography, ToggleSwitch } from 'src/modules/core/components'
import { ChangeEvent } from 'react'
import classes from './template-name-field.module.scss'

import type { TemplateNameFieldProps } from './template-name-field.interface'

export const TemplateNameField = memo(
  forwardRef<HTMLInputElement & HTMLTextAreaElement, TemplateNameFieldProps>(
    (
      {
        id = uniqid(),
        error,
        label,
        className,
        labelClassName,
        children,
        isDefault,
        onIsDefaultChange,
        isReadOnly = false,
        showSaveFirstText = false,
        ...props
      },
      ref,
    ) => {
      return (
        <div className={classNames(classes.root)}>
          <div className={classes.labelRow}>
            <div className={classes.labelWrapper}>
              {label && (
                <label htmlFor={id}>
                  <Typography
                    className={classNames(classes.label, labelClassName, {
                      [classes.labelError]: !!error,
                    })}
                    variant="body"
                  >
                    {label}
                  </Typography>
                </label>
              )}
              {children}
            </div>
            <div className={classes.switchContainer}>
              <ToggleSwitch
                labelClassName={classes.switchLabel}
                onChange={(e: ChangeEvent<HTMLInputElement>) => onIsDefaultChange?.(e.target.checked)}
                checked={isDefault}
                disabled={isReadOnly}
              />
              <Typography variant="body" className={classes.infoText}>
                {isDefault ? 'This is the default template' : 'Set as default template'}
                {showSaveFirstText && !isDefault && ' (save the template first)'}
              </Typography>
            </div>
          </div>
          <input
            className={classNames(classes.input, className, {
              [classes.inputError]: !!error,
            })}
            ref={ref}
            type="text"
            id={id}
            {...props}
          />
          {error && (
            <Typography className={classes.error} variant="body">
              {error}
            </Typography>
          )}
        </div>
      )
    },
  ),
)

TemplateNameField.displayName = 'TemplateNameField'
